module.exports = __webpack_public_path__ + "static/media/undraw_personal_finance_tqcd.50254928.png";